<template>
  <SectionLayout>
    <template #header>
      <SectionLayoutHeader
        title="COMMUNITY DISCUSSIONS"
        number="829.23389.44"
      />
    </template>
    <NewsForumContent />
    <template #footer>
      <SectionLayoutFooter />
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from '@/components/Layout/SectionLayout'
import SectionLayoutHeader from '@/components/Layout/SectionLayoutHeader'
import SectionLayoutFooter from '@/components/Layout/SectionLayoutFooter'
import NewsForumContent from '@/components/News/NewsForumContent'

export default {
  name: 'Forum',

  components: { NewsForumContent, SectionLayout, SectionLayoutFooter, SectionLayoutHeader },
}
</script>
